import { useState, useCallback } from 'react';

export function useConfirmation() {
  const [confirmModal, setConfirmModal] = useState({
    isOpen: false,
    title: '',
    message: '',
    variant: 'danger',
    confirmText: 'Confirm',
    onConfirm: () => {},
    isLoading: false
  });

  const showConfirmation = useCallback((options) => {
    setConfirmModal({
      isOpen: true,
      title: options.title,
      message: options.message,
      variant: options.variant || 'danger',
      confirmText: options.confirmText || 'Confirm',
      onConfirm: options.onConfirm,
      isLoading: false
    });
  }, []);

  const closeConfirmation = useCallback(() => {
    setConfirmModal(prev => ({ ...prev, isOpen: false }));
  }, []);

  return { confirmModal, showConfirmation, closeConfirmation };
}
